import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import QCGuidePage from "@/pages/article/qc-guide/page";
import VersandGuidePage from "@/pages/article/versand-guide/page";
import VergleichPage from "@/pages/article/vergleich/page";
import EinkaufsguidePage from "@/pages/article/einkaufsguide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-versand-guide",
    element: <VersandGuidePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-vergleich",
    element: <VergleichPage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-einkaufsguide",
    element: <EinkaufsguidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;